export const LONG_LIVED_ACCESS_TOKEN_THRESHOLD_SECONDS = 24 * 60 * 60;
export const ACCESS_TOKEN_EXPIRY_SKEW_SECONDS = 60;

type AccessTokenLifetimePayload = {
  exp?: unknown;
  iat?: unknown;
};

export function isLongLivedAccessToken(
  accessToken: string,
  thresholdSeconds = LONG_LIVED_ACCESS_TOKEN_THRESHOLD_SECONDS
): boolean {
  const payload = decodeJwtPayload(accessToken);
  const issuedAt = payload?.iat;
  const expiresAt = payload?.exp;

  if (typeof issuedAt !== 'number' || typeof expiresAt !== 'number') {
    return false;
  }

  return expiresAt - issuedAt > thresholdSeconds;
}

/**
 * Проверяет только доказанное истечение JWT. Битый/не-JWT токен не считаем
 * «просроченным»: socket disconnect может означать блокировку пользователя или
 * tenant, и в таком случае нельзя вслепую вращать RT. HTTP-путь позже вернёт
 * авторитетный 401 и завершит сессию штатно.
 */
export function isAccessTokenExpired(
  accessToken: string,
  nowSeconds = Math.floor(Date.now() / 1000),
  skewSeconds = ACCESS_TOKEN_EXPIRY_SKEW_SECONDS
): boolean {
  const expiresAt = decodeJwtPayload(accessToken)?.exp;

  return typeof expiresAt === 'number' && expiresAt <= nowSeconds + skewSeconds;
}

function decodeJwtPayload(accessToken: string): AccessTokenLifetimePayload | null {
  const [, payload] = accessToken.split('.');

  if (!payload) {
    return null;
  }

  try {
    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const paddedPayload = normalizedPayload.padEnd(
      Math.ceil(normalizedPayload.length / 4) * 4,
      '='
    );

    return JSON.parse(atob(paddedPayload));
  } catch (error) {
    return null;
  }
}
